"use client"

import type { I18nLocale } from "@/modules/i18n/types"
import type { AnchorHTMLAttributes, FunctionComponent, PropsWithChildren } from "react"

import { useLocale } from "@/modules/locales/useLocale"
import { Link } from "@/modules/routing/components/Link"
import { getUpdatedHrefWithLocale } from "@/modules/routing/helpers/getUpdatedHrefWithLocale"
import { useHref } from "@/modules/routing/hooks/useHref"

type AppLocalesDropdownItemLinkProps = PropsWithChildren<
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
    locale: I18nLocale
  }
>

export const AppLocalesDropdownItemLink: FunctionComponent<AppLocalesDropdownItemLinkProps> = ({
  children,
  locale,
  ...props
}) => {
  const currentLocale = useLocale()
  const href = useHref()

  return (
    <Link {...props} href={getUpdatedHrefWithLocale(href, currentLocale, locale)}>
      {children}
    </Link>
  )
}
